"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateFolderExtendedAttributes = generateFolderExtendedAttributes;
exports.parseFolderExtendedAttributes = parseFolderExtendedAttributes;
exports.generateFileExtendedAttributes = generateFileExtendedAttributes;
exports.parseFileExtendedAttributes = parseFileExtendedAttributes;
function generateFolderExtendedAttributes(claimedModificationTime) {
    if (!claimedModificationTime) {
        return undefined;
    }
    return JSON.stringify({
        Common: {
            ModificationTime: dateToIsoString(claimedModificationTime),
        },
    });
}
function dateToIsoString(date) {
    const isDateValid = !Number.isNaN(date.getTime());
    return isDateValid ? date.toISOString() : undefined;
}
function parseFolderExtendedAttributes(logger, extendedAttributes) {
    if (!extendedAttributes) {
        return {};
    }
    try {
        const parsed = JSON.parse(extendedAttributes);
        return {
            claimedModificationTime: parseModificationTime(logger, parsed),
        };
    }
    catch (error) {
        logger.error(`Failed to parse extended attributes`, error);
        return {};
    }
}
function generateFileExtendedAttributes(options) {
    const commonAttributes = {};
    if (options.modificationTime) {
        commonAttributes.ModificationTime = dateToIsoString(options.modificationTime);
    }
    if (options.size !== undefined) {
        commonAttributes.Size = options.size;
    }
    if (options.blockSizes?.length) {
        commonAttributes.BlockSizes = options.blockSizes;
    }
    if (options.digests?.sha1) {
        commonAttributes.Digests = {
            SHA1: options.digests.sha1,
        };
    }
    if (!Object.keys(commonAttributes).length) {
        return undefined;
    }
    return JSON.stringify({
        Common: commonAttributes,
    });
}
function parseFileExtendedAttributes(logger, extendedAttributes) {
    if (!extendedAttributes) {
        return {};
    }
    try {
        const parsed = JSON.parse(extendedAttributes);
        const claimedAdditionalMetadata = { ...parsed };
        delete claimedAdditionalMetadata.Common;
        return {
            claimedSize: parseSize(logger, parsed),
            claimedModificationTime: parseModificationTime(logger, parsed),
            claimedDigests: parseDigests(logger, parsed),
            claimedAdditionalMetadata: Object.keys(claimedAdditionalMetadata).length ? claimedAdditionalMetadata : undefined,
        };
    }
    catch (error) {
        logger.error(`Failed to parse extended attributes`, error);
        return {};
    }
}
function parseSize(logger, xattr) {
    const size = xattr?.Common?.Size;
    if (size === undefined) {
        return undefined;
    }
    if (typeof size !== 'number') {
        logger.warn(`XAttr file size "${size}" is not valid`);
        return undefined;
    }
    return size;
}
function parseModificationTime(logger, xattr) {
    const modificationTime = xattr?.Common?.ModificationTime;
    if (modificationTime === undefined) {
        return undefined;
    }
    const modificationDate = new Date(modificationTime);
    // This is the best way to check if date is "Invalid Date". :shrug:
    if (JSON.stringify(modificationDate) === 'null') {
        logger.warn(`XAttr modification time "${modificationTime}" is not valid`);
        return undefined;
    }
    return modificationDate;
}
function parseDigests(logger, xattr) {
    const digests = xattr?.Common?.Digests;
    if (digests === undefined || digests.SHA1 === undefined) {
        return undefined;
    }
    const sha1 = digests.SHA1;
    if (typeof sha1 !== 'string') {
        logger.warn(`XAttr digest SHA1 "${sha1}" is not valid`);
        return undefined;
    }
    return {
        sha1,
    };
}
//# sourceMappingURL=extendedAttributes.js.map